module.exports = new __parcel__URL__("Whiteboards.0d1dad24.svg").toString();